<template>
  <ValidationObserver @submit="addNewResult">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :modal-show="modal"
      :modal-width="50"
      @handleClick="handleClickCancel"
    >
      <template v-slot:header>
        <span>
          <span v-if="!edit">Add Subject Exam Result</span>
          <span v-else>Edit Subject Exam Result</span>
        </span>
      </template>
      <template v-slot>
        <div>
          <InputFieldWrapper>
            <UiSingleSelect
              v-if="!currentSectionScope && !edit"
              v-model="selectedSection"
              title="Section"
              :options="sectionList"
              label="title"
              reduce="id"
              rules="required"
              :search-through-api="true"
              @change="fetchSubjectsList"
              @deSelect="fetchSubjectsList"
              @search="filterSections"
            />
            <InputBox
              v-model="examData.title"
              type="text"
              name="TITLE"
              title="TITLE"
              label="TITLE"
              placeholder="TITLE"
              rules="required"
            />
            <InputBox
              v-model="examData.description"
              type="text"
              name="Description"
              title="Description"
              label="Description"
              placeholder="Description"
            />
            <UiSingleSelect
              v-model="examData.subject_id"
              title="SUBJECT"
              rules="required"
              :label="'title'"
              :reduce="'id'"
              :disabled="isSubjectDisabled"
              :options="subjectsList"
              :search-through-api="true"
              @change="getExamsList(examData.subject_id)"
              @deSelect="getExamsList(examData.subject_id)"
              @search="getSubjectList"
            />
            <UiSingleSelect
              v-model="examData.non_gpa_grading_id"
              title="GRADING_STRUCTURE"
              rules="required"
              label="title"
              :reduce="'id'"
              :options="nonGPAGradingStructureList"
              :search-through-api="true"
              @change="updatePassingPercentageHandler(examData.non_gpa_grading_id)"
              @deSelect="updatePassingPercentageHandler()"
              @search="filterGradingStructures"
            />
          </InputFieldWrapper>
          <div class="flex flex-col sm:flex-row gap-2 text-base" text-base>
            <div>
              <span v-i18n="placeholder">PASS_PER</span>
              :
            </div>
            <div>{{ examData.passing_percentage || GENERAL_CONSTANT.AMOUNT_ZERO }}%</div>
          </div>
          <Divider v-if="!edit" />
          <!-- Headers -->
          <div v-if="!edit">
            <div class="flex justify-end mb-5">
              <UIButton class="px-5" type="button" @click="addNewGradeItem">Add New Exams</UIButton>
            </div>
            <div>
              <div v-for="(exam, index) in examList" :key="index" class="">
                <div class="grid sm:grid-cols-[1fr_1fr_1fr_12px] gap-2">
                  <UiSingleSelect
                    v-model="exam['subject_exam_schedule_id']"
                    title="Exam"
                    rules="required"
                    :dynamic-title="true"
                    :name="`EXAM + ${index}`"
                    label="title"
                    reduce="id"
                    :options="subjectsExamList"
                    :search-through-api="true"
                    @change="addTotalMarksInExam(exam.subject_exam_schedule_id, index)"
                    @deSelect="addTotalMarksInExam(exam.subject_exam_schedule_id, index)"
                    @search="filterExamList"
                  />
                  <InputBox
                    v-model.number="exam.total_marks"
                    type="text"
                    :name="`EXAM_TOTAL_MARKS + ${index}`"
                    title="Total Marks"
                    label="Total Marks"
                    :is-not-translated="true"
                    :placeholder="`${exam.total_marks || 0}`"
                    :disabled="true"
                  />
                  <InputBox
                    v-model.number="exam['weightage']"
                    type="text"
                    title="Weightage"
                    :is-not-translated="true"
                    :name="`EXAM_WEIGHTAGE + ${index}`"
                    label="Weightage"
                    placeholder="Weightage"
                    rules="numeric|required"
                  />
                  <span
                    v-if="examList.length > 1"
                    class="sm:self-center self-end"
                    @click="removeExamItem(index)"
                  >
                    <icon
                      class="icon cursor-pointer"
                      width="12"
                      height="12"
                      color="mahroon-strong"
                      icon="cross"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!edit">
            <div class="flex justify-end mb-5">
              <UIButton class="px-5" type="button" @click="addNewAssignment">
                Add New Assignment
              </UIButton>
            </div>
            <div>
              <div v-for="(assignment, index) in assignmentsList" :key="index" class="">
                <div class="grid sm:grid-cols-[1fr_1fr_1fr_12px] gap-2">
                  <UiSingleSelect
                    v-model="assignment['assignment_id']"
                    title="Assignment"
                    :dynamic-title="true"
                    :name="`ASSIGNMENT + ${index}`"
                    label="title"
                    reduce="id"
                    :options="subjectsAssignmentsList"
                    @change="addTotalMarksInAssignment(assignment.assignment_id, index)"
                    @deSelect="addTotalMarksInAssignment(assignment.assignment_id, index)"
                  />
                  <InputBox
                    v-model.number="assignment.total_marks"
                    type="text"
                    :name="`ASSIGNMENT_TOTAL_MARKS + ${index}`"
                    title="Total Marks"
                    label="Total Marks"
                    :is-not-translated="true"
                    :placeholder="`${assignment.total_marks || 0}`"
                    :disabled="true"
                  />
                  <InputBox
                    v-model.number="assignment['weightage']"
                    type="text"
                    title="Weightage"
                    :is-not-translated="true"
                    :name="`ASSIGNMENT_WEIGHTAGE + ${index}`"
                    label="Weightage"
                    placeholder="Weightage"
                    :rules="assignment['assignment_id'] && 'numeric|required'"
                  />
                  <span class="sm:self-center self-end" @click="removeAssignmentItem(index)">
                    <icon
                      class="icon cursor-pointer"
                      width="12"
                      height="12"
                      color="mahroon-strong"
                      icon="cross"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton @click="handleClickCancel">Cancel</UIButton>
          <UIButton button="primary" :disabled="isLoading">
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>
              {{ edit ? 'Update' : 'Save' }}
            </span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import InputBox from '@components/UiElements/UiInputBox.vue'
import { mapActions, mapState } from 'vuex'
import Loader from '@components/BaseComponent/Loader.vue'
import Divider from '@src/components/Divider.vue'
import UIButton from '@src/components/UiElements/UIButton.vue'
import icon from '@components/icons/icon.vue'
import { objectDeepCopy } from '@utils/generalUtil'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import GENERAL_CONSTANT from '@src/constants/general-constants'
import { buildWhereQuery } from '@src/utils/filters/index.js'
import FILTER_KEYS, { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { Form as ValidationObserver } from 'vee-validate'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  components: {
    UiModalContainer,
    InputBox,
    ValidationObserver,
    Loader,
    Divider,
    UIButton,
    icon,
    UiSingleSelect,
    InputFieldWrapper,
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['toggle'],
  data() {
    return {
      GENERAL_CONSTANT,
      FILTERS_LIST,
      placeholder: 'placeholder',
      newExam: { subject_exam_schedule_id: '', weightage: '' },
      examData: {
        title: '',
        description: '',
        subject_id: '',
        non_gpa_grading_id: '',
        passing_percentage: '',
      },
      examList: [{ subject_exam_schedule_id: '', weightage: '' }],
      assignmentsList: [{ assignment_id: '', weightage: '' }],
      newAssignment: { assignment_id: '', weightage: '' },
      isLoading: false,
      subjectsList: [],
      subjectsExamList: [],
      subjectsAssignmentsList: [],

      nonGPAGradingStructureList: [],
      totalMarks: 0,
      selectedSection: null,
    }
  },
  computed: {
    ...mapState({
      currentSectionScope: (state) => state.layout.currentSectionScope,
      sectionList: (state) => state.section.sectionList,
    }),
    isSubjectDisabled() {
      return !!this.edit || !(this.currentSectionScope?.id || this.selectedSection)
    },
  },
  watch: {
    examList: {
      deep: true,
      handler(list) {
        this.totalMarks = 0
        list.forEach((exam) => {
          if (exam.total_marks) this.totalMarks += (exam.total_marks / 100) * exam.weightage
        })
      },
    },
  },

  created() {
    if (this.edit) this.setFormDate()
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.getNonGPAStructureList(), this.classSubjects()]).then((response) => {
        let [structureListResponse] = response[0]
        this.nonGPAGradingStructureList = structureListResponse?.data.records || []
        this.subjectsList = response[1]?.data?.records
      })
      this.filterSectionsList()
    },

    fetchSubjectsList() {
      this.examData.subject_id = ''
      this.subjectsExamList = []
      this.examList = [{ subject_exam_schedule_id: '', weightage: '' }]
      let payload = {
        $where: {
          ...buildWhereQuery(
            FILTER_KEYS.EQUAL,
            'section_id',
            this.selectedSection || this.currentSectionScope?.id,
          ),
        },
      }
      this.classSubjects(payload).then((response) => {
        this.subjectsList = response.data.records
      })
    },

    getExamsList(id) {
      this.subjectsExamList = []
      let newExam = objectDeepCopy(this.newExam)
      this.examList = [{ ...newExam }]
      this.subjectsAssignmentsList = []
      this.assignmentsList = [{ ...this.newAssignment }]
      if (id) {
        let filterQueries = {
          $where: {
            ...buildWhereQuery(FILTER_KEYS.EQUAL, 'subject_id', id),
            ...buildWhereQuery(
              FILTER_KEYS.EQUAL,
              'section_id',
              this.selectedSection || this.currentSectionScope?.id,
            ),
          },
        }

        let payload = filterQueries
        if (this.currentSectionScope?.id || this.selectedSection) {
          this.getExamsSubjectsList(payload).then((response) => {
            this.subjectsExamList = response.data.records
          })
          this.getAssignments(payload).then((response) => {
            this.subjectsAssignmentsList = response.data.records
          })
        }
      }
    },

    addNewGradeItem() {
      let newExam = objectDeepCopy(this.newExam)
      this.examList.push(newExam)
    },
    addNewAssignment() {
      this.assignmentsList.push(this.newAssignment)
    },
    updatePassingPercentageHandler(id) {
      const gradingStructure = this.nonGPAGradingStructureList.find(
        (structure) => structure.id === id,
      )
      this.examData.passing_percentage = gradingStructure ? gradingStructure.default_less_than : ''
    },
    addTotalMarksInExam(exam_id, index) {
      this.subjectsExamList.forEach((exam) => {
        if (!exam_id) {
          this.examList[index]['total_marks'] = null
          return
        }
        if (exam.id === exam_id) this.examList[index]['total_marks'] = exam.total_marks
      })
    },
    addTotalMarksInAssignment(assignment_id, index) {
      this.subjectsAssignmentsList.forEach((assignment) => {
        if (!assignment_id) {
          this.assignmentsList[index]['total_marks'] = null
          return
        }
        if (assignment.id === assignment_id)
          this.assignmentsList[index]['total_marks'] = assignment.marks
      })
    },
    removeExamItem(exam_index) {
      this.examList.splice(exam_index, 1)
    },
    removeAssignmentItem(assignment_index) {
      this.assignmentsList.splice(assignment_index, 1)
    },

    handleClickCancel() {
      this.$emit('toggle')
    },
    async addNewResult() {
      this.isLoading = true
      let payload = { structure: this.getPayload() }
      if (this.edit) payload.id = this.edit?.id
      this.addSubjectResult(payload).then(() => {
        this.$emit('toggle', true)
      })
      this.isLoading = false
    },
    filteredAssignmentsList(assignmentsList) {
      return assignmentsList.filter(
        (item) => item.assignment_id.trim() !== '' || item.weightage.trim() !== '',
      )
    },
    getPayload() {
      if (this.selectedSection || this.currentSectionScope?.id)
        this.examData.section_id = this.selectedSection || this.currentSectionScope?.id
      return {
        ...this.examData,
        ...{ subject_exam_schedule_weightages: this.examList },
        ...{
          subject_exam_assignment_weightages: this.filteredAssignmentsList(this.assignmentsList),
        },
      }
    },
    getSubjectList(query = '') {
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query),
          ...buildWhereQuery(
            FILTER_KEYS.EQUAL,
            'section_id',
            this.selectedSection || this.currentSectionScope?.id,
          ),
        },
      }
      this.classSubjects(payload).then((resp) => {
        this.subjectsList = resp.data?.records || []
      })
    },
    filterSections(query = '') {
      const payload = {
        $where: { ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query) },
      }
      this.filterSectionsList(payload)
    },
    filterGradingStructures(query = '') {
      const payload = {
        $where: { ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query) },
      }
      this.getNonGPAStructureList(payload).then((resp) => {
        this.nonGPAGradingStructureList = resp[0].data.records || []
      })
    },
    filterExamList(query = '') {
      const payload = {
        $where: {
          ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query),
          ...buildWhereQuery(FILTER_KEYS.EQUAL, 'subject_id', this.examData.subject_id),
          ...buildWhereQuery(
            FILTER_KEYS.EQUAL,
            'section_id',
            this.selectedSection || this.currentSectionScope?.id,
          ),
        },
      }
      if (this.examData?.subject_id) {
        this.getExamsSubjectsList(payload).then((resp) => {
          this.subjectsExamList = resp.data.records || []
        })
      }
    },
    setFormDate() {
      this.examData.title = this.edit?.title || ''
      this.examData.description = this.edit?.description || ''
      this.examData.non_gpa_grading_id = this.edit?.non_gpa_grading_id || ''
      this.examData.passing_percentage = this.edit?.passing_percentage || ''
      this.examData.subject_id = this.edit?.subject_id || ''
    },
    ...mapActions('exams', [
      'addNonGPAGradingStructure',
      'getExamsSubjectsList',
      'getNonGPAStructureList',
      'addSubjectResult',
    ]),
    ...mapActions('assignment', ['getAssignments']),
    ...mapActions('subjects', ['classSubjects']),
    ...mapActions('section', ['filterSectionsList']),
  },
}
</script>
